import React from 'react';
import './WhyChooseSection.css';

const features = [
  {
    icon: (
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="24" fill="#E6F6F4"/>
        <path d="M28 18L36 22V29C36 34 28 38 28 38C28 38 20 34 20 29V22L28 18Z" stroke="#359F95" strokeWidth="2.5" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'UV Protection',
    desc: 'Blocks up to 100% of harmful UV rays, protecting your skin and preventing interior fading',
  },
  {
    icon: (
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="24" fill="#E6F6F4"/>
        <path d="M28 18V14M28 38V34M18 28H14M38 28H34M33.92 18.48L36.28 16.12M16.12 36.28L18.48 33.92M33.92 33.92L36.28 36.28M16.12 16.12L18.48 18.48" stroke="#359F95" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    ),
    title: 'Energy Savings',
    desc: 'Cuts heat by rejecting up to 80% of total solar energy',
  },
  {
    icon: (
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="24" fill="#E6F6F4"/>
        <path d="M40 28L28 40L16 28" stroke="#359F95" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Nano Technology',
    desc: 'Proprietary nano-ceramic particles provide superior performance without metal interference',
  },
  {
    icon: (
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="24" fill="#E6F6F4"/>
        <path d="M28 18L36 22V29C36 34 28 38 28 38C28 38 20 34 20 29V22L28 18Z" stroke="#359F95" strokeWidth="2.5" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Skin Cancer Prevention',
    desc: 'Acts as a daily defense shield against UV rays linked to skin cancer development.',
  },
  {
    icon: (
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="24" fill="#E6F6F4"/>
        <path d="M28 18L36 22V29C36 34 28 38 28 38C28 38 20 34 20 29V22L28 18Z" stroke="#359F95" strokeWidth="2.5" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Skin Safety',
    desc: 'Dermatologist recommended for protection against harmful UVA and UVB rays',
  },
  {
    icon: (
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="28" cy="28" r="24" fill="#E6F6F4"/>
        <path d="M28 18V38M18 28H38" stroke="#359F95" strokeWidth="2.5" strokeLinecap="round"/>
        <circle cx="28" cy="28" r="10" stroke="#359F95" strokeWidth="2.5"/>
      </svg>
    ),
    title: 'Global Standards',
    desc: 'Exceeds international safety and performance standards in over 50 countries',
  },
];

const WhyChooseSection = () => (
  <section className="why-choose-section">
    <h2 className="why-choose-title">Why Choose Derma Protec</h2>
    <p className="why-choose-subtitle">Our advanced technology sets the industry standard for quality and performance</p>
    <div className="why-choose-list">
      {features.map((feature, idx) => (
        <div className="why-choose-card" key={feature.title}>
          <div className="why-choose-icon">{feature.icon}</div>
          <div className="why-choose-card-title">{feature.title}</div>
          <div className="why-choose-card-desc">{feature.desc}</div>
        </div>
      ))}
    </div>
  </section>
);

export default WhyChooseSection; 